import { Helpers } from '../../helpers';
import { IGasCalculation } from '../../interfaces/igas-calculation';
import { ForecastHorizontal } from '../forecast-horizontal';

export class GasCalculationBase {
  GasCalculationId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ForecastHorizontal_GasCalculation?: Array<ForecastHorizontal> | null;

  constructor(item?: IGasCalculation) {
    if (item) {

      this.GasCalculationId = item.GasCalculationId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontal_GasCalculation = Helpers.createClassArray(ForecastHorizontal, item.ForecastHorizontal_GasCalculation);
    }
  }
}